import { User, Users } from 'lucide-react'
import type { OccupancyUnit } from '@/shared/domain'
import { occupancyUnitWord } from '@/shared/domain'
import { cn } from '@/shared/ui/cn'

type OccupancyBadgeProps = {
  booked: number
  capacity: number
  unit?: OccupancyUnit
}

export function OccupancyBadge({ booked, capacity, unit }: OccupancyBadgeProps) {
  const overflow = booked >= capacity
  const high = !overflow && capacity > 0 && booked / capacity >= 0.75
  const colors = overflow
    ? 'bg-destructive/15 text-destructive'
    : high
      ? 'bg-amber-soft text-amber'
      : 'bg-sage-soft text-sage'
  const Icon = unit === 'groups' ? Users : User
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium tabular-nums',
        colors,
      )}
    >
      {unit ? <Icon aria-hidden className="size-3 shrink-0" /> : null}
      {booked}/{capacity}
      {unit === 'groups' ? ` ${occupancyUnitWord(unit, capacity)}` : null}
    </span>
  )
}
